import { combineReducers } from "redux";

import { auth } from "./auth/reducer";
import { city } from "./city/reducer";
import Layout from "./layouts/reducer";
import { grade } from "./grade/reducer";
import { course } from "./course/reducer";
import { school } from "./school/reducer";
import { governorate } from "./governorate/reducer";
import { subject } from "./subject/reducer";
import { chapter } from "./chapter/reducer";
import { lesson } from "./lesson/reducer";
import { question } from "./question/reducer";
import { courseDuration } from "./course-duration/reducer";
import { skill } from "./skill/reducer";
import { flashCard } from "./flash-card/reducer";
import { calendarEvent } from "./calendar/reducer";
import { appSettings } from "./app-settings/reducer";
import { supplication } from "./supplication/reducer";
import { banner } from "./banner/reducer";
import { account } from "./account/reducer";
import { teacherAdminUser } from "./user/teacher-admin/reducer";
import { olympic } from "./olympic/reducer";
import { LOGOUT_USER_SUCCESS } from "./auth/actionTypes";
import { promoCode } from "./promo-code/reducer";
import { plan } from "./plan/reducer";
import { students } from "./user/student/reducer";
import { user } from "./user/user/reducer";
import { parents } from "./user/parent/reducer";
import { teachers } from "./user/teacher/reducer";
import { analytics } from "./analytics/reducer";
import { notification } from "./notification/reducer";
import { subjectNote } from "./subject-note/reducer";
import { lecture } from "./lecture/reducer";
import { complaint } from "./complaints/reducer";
import { transaction } from "./transaction/reducer";
import { purchase } from "./purchase/reducer";
import { report } from "./report/reducer";
import { appConfigs } from "./app-config/reducer";
import { homeworkSolution } from "./homework-solution/reducer";
import { subscription } from "./subscription/reducer";
import { template } from "./template/reducer";

const appReducer = combineReducers({
  Layout,
  auth,
  governorate,
  city,
  school,
  course,
  grade,
  subject,
  chapter,
  lesson,
  question,
  courseDuration,
  skill,
  flashCard,
  calendarEvent,
  appSettings,
  supplication,
  banner,
  account,
  teacherAdminUser,
  olympic,
  promoCode,
  plan,
  students,
  user,
  parents,
  teachers,
  analytics,
  notification,
  subjectNote,
  lecture,
  complaint,
  transaction,
  purchase,
  report,
  appConfigs,
  homeworkSolution,
  subscription,
  template,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === LOGOUT_USER_SUCCESS) {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default rootReducer;
